/**
 * @owner @Appboy/core-objects
 */
export const customObjectsImportStagingRecords = "/data_objects/import_staging_records" as const;
